var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-lx",
    _vm._b({}, "dialog-lx", _vm.dialogDataLeader, false, true),
    [
      _c("div", { staticClass: "content-main" }, [
        _c("div", { staticClass: "dialog-header" }, [
          (_vm.activeLeaderList && _vm.activeLeaderList.length) ||
          _vm.selectLeaderList.length
            ? _c(
                "div",
                [
                  _vm._l(_vm.activeLeaderList, function (tag) {
                    return _c(
                      "el-tag",
                      {
                        key: tag.playerName,
                        attrs: { closable: "" },
                        on: {
                          close: function ($event) {
                            return _vm.closeTag(tag, "activeLeaderList")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(tag.playerName) + " ")]
                    )
                  }),
                  _vm._l(_vm.selectLeaderList, function (tag) {
                    return _c(
                      "el-tag",
                      {
                        key: tag.playerName,
                        attrs: { closable: "" },
                        on: {
                          close: function ($event) {
                            return _vm.closeTag(tag, "selectLeaderList")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(tag.playerName) + " ")]
                    )
                  }),
                ],
                2
              )
            : _c(
                "span",
                {
                  staticStyle: {
                    display: "inline-block",
                    "text-overflow": "ellipsis",
                    overflow: "hidden",
                    width: "100%",
                    padding: "10px",
                    "box-sizing": "border-box",
                  },
                  style:
                    _vm.lang == "zh_CN"
                      ? "line-height:36px"
                      : "line-height:20px",
                  attrs: { title: _vm.$t("planLxDetail.JYXXSZWDZ") },
                },
                [_vm._v(" " + _vm._s(_vm.$t("planLxDetail.JYXXSZWDZ")) + " ")]
              ),
        ]),
        _c("div", { staticClass: "dialog-content" }, [
          _c("div", { staticClass: "content-header" }, [
            _c(
              "span",
              [
                _c("el-input", {
                  staticStyle: { margin: "0 16px" },
                  attrs: {
                    placeholder: _vm.$t("planLxDetail.QRSXSXM"),
                    size: "mini",
                  },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.seachStudentTableData.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.leaderInputVal,
                    callback: function ($$v) {
                      _vm.leaderInputVal = $$v
                    },
                    expression: "leaderInputVal",
                  },
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.seachStudentTableData },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.CX")) + " ")]
                ),
              ],
              1
            ),
            _c("span", [
              _vm._v(" " + _vm._s(_vm.$t("planLxDetail.YX")) + " "),
              _c(
                "span",
                { staticStyle: { "font-size": "18px", color: "#5397F7" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.activeLeaderList.length + _vm.selectLeaderList.length
                    )
                  ),
                ]
              ),
              _vm._v(" " + _vm._s(_vm.$t("planLxDetail.R")) + " "),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "table-box" },
            [
              _c("c-table", {
                ref: "child",
                attrs: {
                  avtiveList: _vm.avtiveList,
                  tableData: _vm.leaderTableData,
                  tableHeader: _vm.rightTableHeader,
                  TableHeight: "314px",
                },
                on: { operation: _vm.operation },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.$emit("prev")
                  _vm.leaderInputVal = ""
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("planLxDetail.SYB")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.saveClick },
            },
            [_vm._v(_vm._s(_vm.$t("planLxDetail.SCTD")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }